{
  "tabs": {
    "chat": "Txat",
    "reminders": "Gogorarazpenak",
    "calendar": "Egutegia",
    "settings": "Ezarpenak"
  },
  "common": {
    "cancel": "Utzi",
    "save": "Gorde",
    "confirm": "Berretsi",
    "delete": "Ezabatu",
    "back": "Atzera",
    "close": "Itxi",
    "edit": "Editatu",
    "search": "Bilatu",
    "all": "Denak",
    "loading": "Kargatzen...",
    "error": "Zerbait gaizki joan da",
    "notFound": "Ez da aurkitu",
    "tryAgain": "Saiatu berriro mesedez",
    "retry": "Saiatu berriro",
    "undo": "Desegin",
    "pullToRefresh": "Tira egin freskatzeko",
    "justNow": "orain dela"
  },
  "auth": {
    "welcome": "Ongi etorri FishMemory-ra",
    "tagline": "Zure WhatsApp gogorarazpen laguntzailea, orain zure poltsikoan.",
    "subtitle": "Zure WhatsApp gogorarazpen laguntzailea, orain zure poltsikoan.",
    "phoneLabel": "Zure WhatsApp zenbakia",
    "phoneHint": "Berrespen kodea WhatsApp bidez bidaliko dugu",
    "invalidPhone": "Sartu zenbaki baliodun bat mesedez",
    "continue": "Jarraitu",
    "enterPhone": "Sartu zure WhatsApp zenbakia",
    "phonePlaceholder": "Telefono zenbakia",
    "sendCode": "Bidali Kodea",
    "verifyTitle": "Berretsi zure zenbakia",
    "otpSentTo": "6 digitu kode bat bidali da {{phone}} helbidera WhatsApp bidez",
    "enterFullCode": "Sartu 6 digitu guztiak mesedez",
    "invalidOtp": "Kode baliogabea. Saiatu berriro.",
    "otpFailed": "Kodea bidaltzea huts egin du. Saiatu berriro.",
    "otpResent": "Kodea berriro bidali da",
    "resendIn": "Berriro bidali {{seconds}}s barru",
    "resendCode": "Berriro bidali kodea",
    "enterOtp": "Sartu WhatsApp-era bidalitako kodea",
    "verify": "Berretsi",
    "resend": "Berriro bidali kodea",
    "wrongNumber": "Zenbaki okerra?",
    "backToPhone": "Itzuli telefonora",
    "editPhone": "Editatu telefono zenbakia",
    "error": "Errorea",
    "setupTitle": "Ezarpenak egin ditzagun",
    "setupSubtitle": "Ezarpenak beti alda ditzakezu geroago",
    "namePlaceholder": "Zure izena",
    "letsGo": "Amaitu ezarpena",
    "skipForNow": "Saltatu orain"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Idatzi mezua...",
    "inputPlaceholder": "Idatzi mezua...",
    "typing": "FishMemory idazten ari da...",
    "online": "Linean",
    "connecting": "Konektatzen...",
    "reconnecting": "Berriro konektatzen...",
    "offline": "Lineaz kanpo",
    "empty": "Hasi elkarrizketa",
    "emptyHint": "Sortu gogorarazpenak, ikusi zure egutegia edo eskatu laguntza.",
    "emptyAction": "Bidali gogorarazpen adibide bat",
    "actions": "Txat ekintzak",
    "keep": "Gorde mezuak",
    "clearTitle": "Garbitu txat",
    "clearConfirm": "Ezabatu mezu guztiak gailu honetatik? Ezinezkoa da atzera egitea.",
    "clear": "Garbitu txat",
    "optionSelected": "Hautatua: {{label}}",
    "sendingSelection": "Bidaltzen...",
    "connectionLost": "Berriro konektatzen..."
  },
  "reminders": {
    "title": "Nire Gogorarazpenak",
    "active": "Aktibo",
    "today": "Gaur",
    "thisWeek": "Aste honetan",
    "history": "Historia",
    "items": "elementu",
    "emptyTitle": "Oraindik ez dago gogorarazpenik",
    "emptySubtitle": "Sortu bat txatean eta hemen agertuko da.",
    "emptyAction": "Ireki txata",
    "filterActive": "Aktibo",
    "filterToday": "Gaur",
    "filterWeek": "Aste honetan",
    "filterHistory": "Historia",
    "emptyState": "Oraindik ez dago gogorarazpenik. Hasi txateatzen!",
    "swipeDone": "Egina",
    "swipeSnooze": "Beranduagotu",
    "swipeDelete": "Ezabatu",
    "search": "Bilatu gogorarazpenak...",
    "upcoming": "Hurrengoa",
    "completed": "Eginda",
    "overdue": "Atzeratua",
    "tomorrow": "Bihar",
    "synced": "Sinkronizatuta {{value}}",
    "swipeHint": "Pasatu hatza gogorarazpen batean ekintza gehiago ikusteko",
    "noResults": "Ez dago bilaketari egokitzen diren gogorarazpenik",
    "noResultsHint": "Saiatu beste hitz gako batekin edo garbitu bilaketa",
    "deleteAllFailed": "Ezin izan dira gogorarazpen guztiak ezabatu"
  },
  "calendar": {
    "title": "Egutegia",
    "today": "Gaur",
    "tomorrow": "Bihar",
    "completed": "eginda",
    "noEvents": "Ez dago ekitaldirik",
    "noEventsSubtitle": "Aukeratu data bat gogorarazpenak eta egutegiko ekitaldiak ikusteko.",
    "googleEvent": "Google Calendar",
    "legendActive": "Aktibo",
    "legendRecurring": "Errepikakorra",
    "legendDone": "Eginda",
    "legendGoogle": "Google",
    "previousMonth": "Hilabete aurrekoa",
    "nextMonth": "Hilabete hurrengoa",
    "previousYear": "Urte aurrekoa",
    "nextYear": "Urte hurrengoa",
    "goToToday": "Joan gaurera",
    "all": "Denak",
    "active": "Aktibo",
    "done": "Eginda",
    "paused": "Etena"
  },
  "settings": {
    "title": "Ezarpenak",
    "profile": "Profila",
    "name": "Erakutsi izena",
    "enterName": "Sartu zure izena",
    "language": "Hizkuntza",
    "uiLanguage": "App hizkuntza",
    "uiLanguageHelp": "Aldatzen du apparen interfazea, egutegiko etiketak eta egitura norabidea gailu honetan bakarrik.",
    "serverLanguage": "Txat hizkuntza",
    "serverLanguageHelp": "Aldatzen du zer hizkuntza erabiltzen duen zerbitzariak zure kontuaren erantzunetan eta gogorarazpen mezuetan.",
    "timezone": "Ordu-eremua",
    "currentTimezone": "Uneko ordu-eremua",
    "timezoneHelp": "Gogorarazpen ordu guztiak ordu-eremu honekin erakusten dira.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Gorde ordu-eremua",
    "timezoneSaved": "Ordu-eremua eguneratua",
    "detect": "Detektatu",
    "detectFailed": "Ezin izan da ordu-eremua detektatu",
    "autoDetect": "GPS-etik automatikoki detektatu",
    "notifications": "Jakinarazpenak",
    "notificationsHelp": "Gogorarazpen jarraipenek kontrolatzen dituzte alerta errepikatuak gogorarazpena entregatu ondoren. Gailuaren jakinarazpen baimenak telefonoaren ezarpenetan kudeatzen dira oraindik.",
    "pushEnabled": "Push jakinarazpenak",
    "autoDoneOnFire": "Automatikoki markatu egina piztutakoan",
    "autoDoneOnFireDesc": "Desaktibatuta dagoenean, gogorarazpenak aktibo jarraitzen dute zuk egina markatu arte.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Konektatuta",
    "googleDisconnected": "Ez konektatuta",
    "googleConnectedHelp": "Gogorarazpen berriak automatikoki sinkroniza daitezke zure egutegian.",
    "googleDisconnectedHelp": "Konektatu Google Calendar gogorarazpenak eta ekitaldiak bat etor daitezen.",
    "googleConnectFailed": "Ezin izan da Google Calendar konektatu",
    "connected": "Konektatuta",
    "disconnected": "Ez konektatuta",
    "connect": "Konektatu",
    "disconnect": "Deskonektatu",
    "autoSync": "Sinkronizazio automatikoa",
    "autosync": "Sinkronizazio automatikoa",
    "subscription": "Harpidetzak",
    "trialUsed": "Proba: {{used}}/{{total}} erabili",
    "trialStatus": "Proba eskuragarri",
    "activeStatus": "Harpidetza aktiboa",
    "expiredStatus": "Harpidetza iraungita",
    "unsubscribedStatus": "Ez da harpidetuta",
    "about": "Honi buruz",
    "version": "Bertsioa",
    "logout": "Saioa itxi",
    "logoutTitle": "Saioa itxi",
    "logoutConfirm": "Ziur zaude saioa itxi nahi duzula?",
    "noName": "Izena ez da ezarri",
    "serverConnection": "Zerbitzari konexioa",
    "serverUrl": "Zerbitzari URL",
    "serverEdit": "Editatu",
    "saveReconnect": "Gorde eta berriro konektatu",
    "resetDefault": "Lehenetsitara berrezarri",
    "invalidServerUrlTitle": "Zerbitzari URL baliogabea",
    "invalidServerUrlMessage": "Sartu http edo https zerbitzari URL baliodun bat, adibidez https://example.com",
    "uiLanguageChangeFailed": "Ezin izan da app hizkuntza aldatu. Saiatu berriro.",
    "serverLanguageChangeFailed": "Ezin izan da txat hizkuntza aldatu. Saiatu berriro.",
    "timezoneChangeFailed": "Ezin izan da ordu-eremua aldatu. Saiatu berriro.",
    "autoSyncChangeFailed": "Ezin izan da sinkronizazio automatikoa eguneratu. Saiatu berriro.",
    "nameChangeFailed": "Ezin izan da erakutsi izena eguneratu. Saiatu berriro.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Gogorarazpenaren xehetasunak",
    "editTime": "Editatu Ordua",
    "rename": "Berrizendatu",
    "snooze": "Beranduagotu",
    "snooze15": "Beranduagotu 15 minutu",
    "pause": "Eten",
    "pauseReminder": "Eten gogorarazpena",
    "resume": "Jarraitu",
    "resumeReminder": "Jarraitu gogorarazpena",
    "skip": "Hurrengoa saltatu",
    "skipOccurrence": "Gertaera hau saltatu",
    "syncGoogle": "Sinkronizatu Google-rekin",
    "delete": "Ezabatu",
    "deleteTitle": "Ezabatu Gogorarazpena",
    "deleteConfirm": "Gogorarazpen hau betiko ezabatuko da.",
    "deleteRecurringTitle": "Ezabatu Gogorarazpen Errepikakorra",
    "deleteRecurringMessage": "Gertaera hau saltatu nahi duzu ala serie osoa ezabatu?",
    "deleteThisOccurrence": "Gertaera hau saltatu",
    "deleteEntireSeries": "Serie osoa ezabatu",
    "done": "Egina",
    "markDone": "Markatu egina",
    "undo": "Berreskuratu",
    "undoPrompt": "Aktibo behar duzu berriro? Berreskuratu orain.",
    "recurring": "Errepikakorra",
    "nextRun": "Hurrengo exekuzioa",
    "oneTime": "Behin bakarra",
    "pending": "Zain",
    "sent": "Bidalia",
    "paused": "Etena",
    "active": "Aktibo",
    "snoozed": "Beranduagotua",
    "localTime": "Zure tokiko orduan erakutsita",
    "recurrence": "Errepikapena",
    "created": "Sortua",
    "tags": "Etiketak",
    "fireCount": "Piztu den aldiz",
    "actions": "Ekintzak",
    "none": "Ezer ez",
    "snoozeFailed": "Ezin izan da gogorarazpena beranduagotu",
    "pauseFailed": "Ezin izan da gogorarazpena eten",
    "resumeFailed": "Ezin izan da gogorarazpena jarraitu",
    "skipFailed": "Ezin izan da gogorarazpena saltatu",
    "doneFailed": "Ezin izan da gogorarazpena egina markatu",
    "undoFailed": "Ezin izan da gogorarazpen egoera berreskuratu",
    "deleteFailed": "Ezin izan da gogorarazpena ezabatu",
    "rescheduleTitle": "Berriro programatu?",
    "rescheduleMsg": "Gogorarazpen hau atzeratua dago. Berriro programatu nahi duzu?",
    "reschedule15": "15 minututan",
    "reschedule60": "1 ordutan",
    "keepOverdue": "Egoera berean utzi"
  },
  "onboarding": {
    "slide1Title": "Ongi etorri FishMemory-ra",
    "slide1Sub": "Zure gogorarazpen laguntzailea — WhatsApp-ekin eta zure poltsikorako eraikia.",
    "slide2Title": "Txateatu modu naturalean",
    "slide2Sub": "Idatzi gogorarazpenak nahi duzun moduan: \"Gogoratu biharko 15:00etan ama deitzea\" — gu bestea kudeatzen dugu.",
    "slide3Title": "Ez galdu ezer",
    "slide3Sub": "Jaso jakinarazpen puntualak, antolatu etiketekin eta jarraitu garrantzitsuen gainean.",
    "getStarted": "Hasi",
    "next": "Hurrengoa",
    "firstReminderTitle": "Sortu zure lehen gogorarazpena!",
    "firstReminderHint": "Saiatu hau idazten:",
    "firstReminderExample": "Gogoratu biharko 9etan ura edatea",
    "gotIt": "Ulertu dut!",
    "notifRationaleTitle": "Egunean egon",
    "notifRationaleBody": "FishMemory-k jakinarazpenak behar ditu denbora egokian gogorarazteko. Zure sortutako gogorarazpenetarako bakarrik jasoko dituzu alerta.",
    "notifRationaleAllow": "Gaitu jakinarazpenak",
    "notifRationaleLater": "Agian geroago",
    "swipeHint": "Pasatu eskuinera ekintza azkarretarako →",
    "calendarDragHint": "Arrastatu zabaltzeko ↕"
  }
}
